<mat-card *ngIf="subjects | async as subjects; else loading">
  <mat-card-header>
    <mat-card-title>Topics</mat-card-title>
    <a mat-button [routerLink]="['/topics/create']" color="primary">Add Topic</a>
  </mat-card-header>

  <mat-card-content>
    <ng-template ngFor let-subject [ngForOf]="subjects">
      <mat-expansion-panel (opened)="openSubject(subject.id)" [expanded]="false">
        <mat-expansion-panel-header>
          <mat-panel-title>{{subject.name}}</mat-panel-title>
          <!-- TODO: Connect buttons up to their functions -->
        </mat-expansion-panel-header>

        <mat-accordion *ngIf="subject.id === selectedSubject">
          <ng-template ngFor let-topic [ngForOf]="subject.topics">

            <!--Topic Start -->
            <mat-expansion-panel [expanded]="false" (opened)="openTopic(topic.id)">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <!--<a routerLink="/topics/{{topic.id}}/edit">-->
                  {{topic.displayName}}
                  <!--</a>-->
                </mat-panel-title>
                <button mat-button color="primary" [routerLink]="['/topics/' + topic.id + '/edit']">
                  Edit
                </button>
              </mat-expansion-panel-header>

              <mat-list>
                <mat-list-item class="w-50">
                  <h3 mat-line>{{topic.displayName}}</h3>
                  <p mat-line class="secondary-text">Name</p>
                </mat-list-item>
                <mat-list-item class="w-50">
                  <h3 mat-line>{{topic.strategyName}}</h3>
                  <p mat-line class="secondary-text">Strategy</p>
                </mat-list-item>
                <mat-list-item class="w-50">
                  <h3 mat-line>{{topic.subject}}</h3>
                  <p mat-line class="secondary-text">Subject</p>
                </mat-list-item>
                <mat-list-item class="w-50">
                  <h3 mat-line>{{topic.slug}}</h3>
                  <p mat-line class="secondary-text">Slug</p>
                </mat-list-item>
                <mat-list-item class="w-50">
                  <h3 mat-line>{{topic.tier1}}</h3>
                  <p mat-line class="secondary-text">Tier 1</p>
                </mat-list-item>
                <mat-list-item class="w-50">
                  <h3 mat-line>{{topic.tier2}}</h3>
                  <p mat-line class="secondary-text">Tier 2</p>
                </mat-list-item>
                <mat-list-item class="w-50">
                  <h3 mat-line>{{topic.tier3}}</h3>
                  <p mat-line class="secondary-text">Tier 3</p>
                </mat-list-item>
                <mat-list-item class="w-50" >
                  <h3 mat-line>{{topic.tier4}}</h3>
                  <p mat-line class="secondary-text">Tier 4</p>
                </mat-list-item>
              </mat-list>
              <p>&nbsp;</p>
              <!-- Problem Start-->
              <mat-accordion *ngIf="topic.id === selectedTopic"  >
                <mat-expansion-panel [expanded]="false">

                  <mat-expansion-panel-header>
                    <mat-panel-title>Problems</mat-panel-title>
                  </mat-expansion-panel-header>

                  <mat-list>
                    <mat-list-item *ngFor="let problem of topic.problems">
                      <a routerLink="/problems/{{problem.id}}/edit">
                        {{problem.title}}
                      </a>
                    </mat-list-item>
                  </mat-list>
                  <mat-action-row>
                    <button mat-raised-button color="primary" routerLink='/problems/create'>
                      Add Problem
                    </button>
                  </mat-action-row>
                </mat-expansion-panel>
              </mat-accordion>

            </mat-expansion-panel>
          </ng-template>
          <!--Problems End-->
          <!--Topic End -->
        </mat-accordion>
      </mat-expansion-panel>
      <!--Subject End-->
    </ng-template>
  </mat-card-content>
</mat-card>

<ng-template #loading>
  <app-spinner></app-spinner>
</ng-template>
